export default __webpack_public_path__ + "static/assets/b4b492579802cc1c7b78384f15a4c994.png";